import { render, staticRenderFns } from "./LoanApprovalTable.vue?vue&type=template&id=4b6123d0&scoped=true"
import script from "./LoanApprovalTable.vue?vue&type=script&lang=js"
export * from "./LoanApprovalTable.vue?vue&type=script&lang=js"
import style0 from "./LoanApprovalTable.vue?vue&type=style&index=0&id=4b6123d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6123d0",
  null
  
)

export default component.exports